import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { OspCategoriesService } from '../services/osp-categories.service';

@Component({
    selector: 'app-custom-osp-empty-search-result-paragraph',
    templateUrl: './custom-osp-empty-search-result-paragraph.component.html',
    styleUrls: ['./custom-osp-empty-search-result-paragraph.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomOspEmptySearchResultParagraphComponent
  implements OnInit, OnDestroy
{
  resultPresent = true;
  query: string;
  contentSub: Subscription;
  constructor(
    public readonly component: CmsComponentData<CmsParagraphComponent>,
    private readonly ospService: OspCategoriesService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.contentSub = this.ospService.contentItemsSearchResult$.subscribe(
      (res) => {
        if (res != null) {
          this.resultPresent = res.products.length > 0;
          this.changeDetectorRef.detectChanges();
        } else {
          this.resultPresent = false;
          this.changeDetectorRef.detectChanges();
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.contentSub?.unsubscribe();
  }
}
